const GroupList = () =>
  import(/* webpackChunkName: "Admin" */ '@/components/admin/groups/GroupList');
const GroupEditor = () =>
  import(/* webpackChunkName: "Admin" */ '@/components/admin/groups/GroupEditor');
const TerminalList = () =>
  import(/* webpackChunkName: "Admin" */ '@/components/admin/terminals/TerminalList');
const TerminalEditor = () =>
  import(/* webpackChunkName: "Admin" */ '@/components/admin/terminals/TerminalEditor');
const ApplicationList = () =>
  import(/* webpackChunkName: "Admin" */ '@/components/admin/applications/ApplicationList');
const ApplicationEditor = () =>
  import(/* webpackChunkName: "Admin" */ '@/components/admin/applications/ApplicationEditor');
const BrandEditor = () =>
  import(/* webpackChunkName: "Admin" */ '@/components/admin/brands/BrandEditor');
const LoadTest = () =>
  import(/* webpackChunkName: "Test" */ '@/components/admin/loadtest/LoadTest');

export default [
  {
    path: '',
    name: 'AdminOverview',
    redirect: { name: 'ApplicationList' },
  },
  {
    path: 'groups',
    name: 'GroupList',
    component: GroupList,
    meta: { label: 'Manage groups' },
  },
  {
    path: 'groups/:id',
    name: 'GroupEditor',
    component: GroupEditor,
    props: true,
  },
  {
    path: 'terminals',
    name: 'TerminalList',
    component: TerminalList,
    meta: { label: 'Manage terminals' },
  },
  {
    path: 'terminals/:id',
    name: 'TerminalEditor',
    component: TerminalEditor,
    props: true,
  },
  {
    path: 'applications',
    name: 'ApplicationList',
    component: ApplicationList,
    meta: { label: 'Manage applications' },
  },
  {
    path: 'applications/:id',
    name: 'ApplicationEditor',
    component: ApplicationEditor,
    props: true,
  },
  {
    path: 'brand',
    name: 'BrandEditor',
    component: BrandEditor,
    props: true,
    meta: { label: 'Manage brand' },
  },
  {
    path: 'loadtest',
    name: 'LoadTest',
    component: LoadTest,
    meta: { label: 'Load test' },
  },
];
